//#region types
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import { useCloseConfirmation } from "components/common";
import FAQCloseConfirmationContent from "./closeConfirmationContent";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useFAQSupportFlowCloseConfirmation() {
  const { showCustomConfirmation } = useCloseConfirmation(true);

  const getCloseConfirmation = (supportTicketDialog: DialogProps) => {
    const closeConfirmationTitle = LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Common.BeforeYouClose
    );

    const showFAQCloseConfirmation = (
      onClose: () => Promise<any>,
      onCreateSupportClick: () => Promise<any>,
      onContinueEditing?: () => Promise<any>
    ) => {
      showCustomConfirmation(
        closeConfirmationTitle,
        <FAQCloseConfirmationContent
          supportTicketDialog={supportTicketDialog}
          onCreateSupportClick={onCreateSupportClick}
        />,
        onClose,
        onContinueEditing
      );
    };

    return { showConfirmation: showFAQCloseConfirmation };
  };

  return { getCloseConfirmation };
}

export default useFAQSupportFlowCloseConfirmation;
